export default __webpack_public_path__ + "static/media/rink.10920c7d.png";